import type { ClaimConfidence, ClaimIntent } from "../types.js";

/**
 * A claim is "soft" when the writer is unsure enough (low/medium confidence) or
 * the claim is illustrative (intent: example) that a missing target should be
 * reported as a warning rather than an error.
 *
 * Use this to gate severity downgrades across the checkers — e.g. a dead
 * command in an "example" block is a teaching artifact, not a broken script.
 */
export function isSoftClaim(claim: {
  confidence: ClaimConfidence;
  intent: ClaimIntent;
}): boolean {
  return (
    claim.confidence === "low" ||
    claim.confidence === "medium" ||
    claim.intent === "example"
  );
}
